<script lang="ts" setup>

import { Badge, BlockContainer, Carousel, CarouselContent, CarouselFooter, CarouselItem, CarouselNext, CarouselPrevious, Separator } from '@toni/brand-ui'
import { ProductCardWithPurchaseOptions } from '@toni/commerce-api-types'

import ProductCardGroupItem from '../ProductCard/ProductCardGroupItem.vue'
import ProductCardGroupMobile from './ProductCardGroupMobile.vue'

const props = defineProps<{
  title: string
  productCards: ProductCardWithPurchaseOptions[]
}>()
const groupOfThrees: ProductCardWithPurchaseOptions[][] = []
for (let i = 0; i < props.productCards.length; i += 3) {
  groupOfThrees.push(props.productCards.slice(i, i + 3))
}
</script>

<template>
  <BlockContainer class="items-center my-6 gap-6">
    <Badge v-if="title"
           type="text"
           variant="tertiary"
           size="xl"
           class="text-badge-xl px-3.5 pt-1 pb-[3px]">
      {{ title }}
    </Badge>
    <ProductCardGroupMobile class="sm:hidden"
                            :product-cards="productCards" />
    <div v-if="productCards.length <= 3"
         :class="`${productCards.length === 2 ? 'gap-12' : 'gap-6'} hidden sm:flex w-full`">
      <ProductCardGroupItem v-for="product in productCards"
                            :key="product.bauerProductCard.bauerProductCardId"
                            :class="`${productCards.length === 2 ? 'basis-1/2' : 'basis-1/3'}`"
                            :product-card="product.bauerProductCard"
                            :purchase-options="product.purchaseOptions" />
    </div>
    <Carousel v-else
              variant="extended"
              class="hidden sm:block">
      <CarouselContent>
        <CarouselItem v-for="group in groupOfThrees"
                      :key="group[0]!.bauerProductCard.bauerProductCardId"
                      class="basis-full">
          <div class="flex gap-7 items-start">
            <ProductCardGroupItem v-for="product in group"
                                  :key="product.bauerProductCard.bauerProductCardId"
                                  class="basis-1/3"
                                  :product-card="product.bauerProductCard"
                                  :purchase-options="product.purchaseOptions" />
          </div>
        </CarouselItem>
      </CarouselContent>
      <Separator class="mt-6" />
      <CarouselFooter>
        <span class="text-badge-lg font-badge text-primary-500 uppercase">
          {{ $t('commerce.productCount', {count: productCards.length}) }}
        </span>
        <span class="flex justify-end gap-4 my-3">
          <CarouselPrevious :use-disabled-opacity="true" />
          <CarouselNext :use-disabled-opacity="true" />
        </span>
      </CarouselFooter>
    </Carousel>
  </BlockContainer>
</template>
